import DashboardOfficerView from '../components/dashboard/DashboardOfficerView';
import DashBoardMapOffice from '../components/dashboard/DashBoardMapOffice';
import DashBoardTransaction from '../components/dashboard/DashBoardTransaction';
import { Tabs } from 'antd';
import URLTabs from '../components/common/URLTabs';

export default function DashboardView() {
  return (
    <URLTabs
      size='large'
      defaultActiveKey='#dashboard'
      items={[
        {
          key: "#dashboard", 
          label: <span>Farmer and plantation</span>, 
          children: <DashboardOfficerView/>
        },
        {
          key: "#map", 
          label: <span>Map</span>,
          children: <DashBoardMapOffice/> 
        },
        {
          key: "#transaction", 
          label: <span>Transaction</span>, 
          children: <DashBoardTransaction/>
        }
      ]}
    />
  )
}
